import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labelForMac: {
		defaultMessage: 'Search ( <wrapper><command>⌘</command> + <key>K</key></wrapper> )',
		id: 'atlassian-navigation.settings.command-palette-search-button.label-for-mac',
		description: 'Label for command palette search button in settings menu',
	},
	labelForOther: {
		defaultMessage: 'Search ( <wrapper><command>Ctrl</command> + <key>K</key></wrapper> )',
		id: 'atlassian-navigation.settings.command-palette-search-button.label-for-other',
		description: 'Label for command palette search button in settings menu',
	},
	labelForMacScreenReader: {
		id: 'atlassian-navigation.settings.command-palette-search-button.label-for-mac-screen-reader',
		defaultMessage: 'Search ( command plus K ) to search Jira settings',
		description:
			'This message is going to be set on the `aria-label` of the button to be read by screen readers only. "command" refers to the key ⌘',
	},
	labelForOtherScreenReader: {
		id: 'atlassian-navigation.settings.command-palette-search-button.label-for-other-screen-reader',
		defaultMessage: 'Search ( control plus K ) to search Jira settings',
		description:
			'This message is going to be set on the `aria-label` of the button to be read by screen readers only. "control" refers to the key Ctrl of the keyboard',
	},
});
